import { styled, Avatar } from "@mui/material";

export const RecommendationAvatar = styled(Avatar)`
  height: 24px;
  width: 24px;
  margin-right: 5px;
  object-fit: fill;
`;
